import { sendRequest } from "@infrastructure/api/api";
import type ApiResponse from "@core/types/apiResponse";
import type { ApiMessageResponse } from "@core/types/apiMessageResponse";

type ReviewCommon = {
  departmentId: number;
  departmentReportId: number;
  /**
   * Reason for the review. The API's RequestReviewDepartmentReportRequest REQUIRES `notes`
   * (required|string|max:255) — callers that omit it get a 422 (the tracked §4b-2 bug on the
   * older District/Nation pages). New callers must pass it.
   */
  notes?: string;
};

export type RequestReportReviewArgs =
  | ({ scope: "nation"; nationId: number } & ReviewCommon)
  | ({ scope: "district"; districtId: number } & ReviewCommon)
  | ({ scope: "church"; churchId: number } & ReviewCommon);

function buildPath(args: RequestReportReviewArgs): string {
  if (args.scope === "nation") {
    return `/nation/${args.nationId}/department/${args.departmentId}/report/requestreview/${args.departmentReportId}`;
  }
  if (args.scope === "district") {
    return `/district/${args.districtId}/department/${args.departmentId}/report/requestreview/${args.departmentReportId}`;
  }
  return `/church/${args.churchId}/department/${args.departmentId}/report/requestreview/${args.departmentReportId}`;
}

export async function requestReportReviewAsync(
  args: RequestReportReviewArgs
): Promise<ApiResponse<ApiMessageResponse>> {
  const url = buildPath(args);

  // Send `notes` when provided (required by the API). Omitting it keeps the legacy
  // no-body behaviour of existing callers untouched.
  if (args.notes !== undefined) {
    return sendRequest<{ notes: string }, ApiMessageResponse>("POST", url, { notes: args.notes });
  }

  return sendRequest<void, ApiMessageResponse>("POST", url);
}
